import api from "./api";

class EquipmentService {
    listTypes() {
        return api.get("/api/equipment/types/");
    }

    listEquipment(equipmentTypeId) {
        return api.get("/api/equipment/assets/", {
            params: equipmentTypeId ? { equipment_type: equipmentTypeId } : {},
        });
    }

    listItems(equipmentTypeId) {
        return api.get("/api/equipment/items/", {
            params: { equipment_type: equipmentTypeId },
        });
    }

    listInspections(params = {}) {
        return api.get("/api/equipment/inspections/", { params });
    }

    createInspection(data) {
        return api.post("/api/equipment/inspections/", data);
    }

    deleteInspection(id) {
        return api.delete(`/api/equipment/inspections/${id}/`);
    }

    listIssues(params = {}) {
        return api.get("/api/equipment/issues/", { params });
    }

    createIssue(data) {
        return api.post("/api/equipment/issues/", data);
    }

    updateIssue(id, data) {
        return api.patch(`/api/equipment/issues/${id}/`, data);
    }
}

export default new EquipmentService();
